// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-footer {
  padding: 20px 0 60px;
  margin: 0 auto;
}

.share {
  margin: 0px;
  padding-bottom: 1rem;
  position: relative;
  display: inline-block;
}
.share:after {
  position: absolute;
  content: "";
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 3px;
  background: #656d4a;
  border-radius: 8px;
}

.share-icons {
  max-width: 800px;
  border-top: 1px solid rgba(0, 0, 0, 0.3);
  margin: 0 auto;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.link-input {
  width: 300px;
  height: 35px;
  padding: 6px;
  border: 2px solid #656d4a;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.link-input:focus-visible {
  outline: none !important;
}
@media (max-width: 640px) {
  .link-input {
    width: 150px;
  }
}

.link-copy {
  width: 7.8rem;
  height: 35px;
  border: 0;
  background-color: #656d4a;
  border: 2px solid #656d4a;
  color: white;
  transform: translateX(-1px);
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  vertical-align: top;
}`, "",{"version":3,"sources":["webpack://./src/Components/PageFooter/PageFooter.scss","webpack://./src/scss/variables.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;AADF;AAGE;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBCpBQ;EDqBR,kBAAA;AADJ;;AAKA;EACE,gBAAA;EACA,wCAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,2BAAA;EACA,8BAAA;AAFF;AAIE;EACE,wBAAA;AAFJ;AAKE;EAZF;IAaI,YAAA;EAFF;AACF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,SAAA;EACA,yBCzDU;ED0DV,yBAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAFF","sourcesContent":["@use '../../scss/variables.scss';\n\n.page-footer {\n  padding: 20px 0 60px;\n  margin: 0 auto;\n}\n\n.share {\n  margin: 0px;\n  padding-bottom: 1rem;\n  position: relative;\n  display: inline-block;\n\n  &:after {\n    position: absolute;\n    content: '';\n    left: 0;\n    bottom: -1px;\n    width: 100%;\n    height: 3px;\n    background: variables.$mainGreen;\n    border-radius: 8px;\n  }\n}\n\n.share-icons {\n  max-width: 800px;\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n  margin: 0 auto;\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n}\n\n.link-input {\n  width: 300px;\n  height: 35px;\n  padding: 6px;\n  border: 2px solid variables.$mainGreen;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n\n  &:focus-visible {\n    outline: none !important;\n  }\n\n  @media (max-width: 640px) {\n    width: 150px;\n  }\n}\n\n.link-copy {\n  width: 7.8rem;\n  height: 35px;\n  border: 0;\n  background-color: variables.$mainGreen;\n  border: 2px solid variables.$mainGreen;\n  color: white;\n  transform: translateX(-1px);\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n  cursor: pointer;\n  font-weight: bold;\n  vertical-align: top;\n}\n","$mainGreen: #656d4a;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
